module.exports = __webpack_public_path__ + "img/skoda.1fb58f11.svg";